/**
 * Newspaper templates — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_office_formats`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const newspaperTemplatesPack: ToilePack = {
    slug: 'newspaper-templates',
    category: 'office',
    name: 'Newspaper templates',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 832, h: 1216},
    readings: [
        {key: 'front', label: 'Front page', subject: 'a newspaper front page with masthead "THE DAILY NEWS" and columns of placeholder lines'},
        {key: 'school', label: 'School paper', subject: 'a school newspaper template'},
        {key: 'vintage', label: 'Vintage', subject: 'a vintage newspaper template'},
    ],
    styles: [
        {key: 'modern', label: 'Modern', style: 'modern broadsheet layout with a bold masthead, thin column rules and framed photo boxes', palette: 'black ink on white', framing: 'single page seen straight on, centered on a plain light grey ground with an even white margin around the sheet'},
        {key: 'class', label: 'Classroom', style: 'cheerful school newspaper with a bright masthead band, rounded boxes and empty picture frames', palette: 'red, yellow and blue on white', framing: 'single page seen straight on, centered on a plain light grey ground with an even white margin around the sheet'},
        {key: 'aged', label: 'Aged', style: 'aged newspaper print with a blackletter masthead, tight columns and double rules on yellowed paper', palette: 'dark brown ink on sepia paper', framing: 'single page seen straight on, centered on a plain light grey ground with an even white margin around the sheet'},
    ],
    directions: ['blue masthead', 'four columns', 'with photo box'],
    directionHint: 'try: blue masthead',
    seo: {
        title: 'Newspaper template: front page, school, vintage',
        metaDescription: 'Nine printable newspaper templates: a front page, a school paper and a vintage paper, each in modern, classroom or aged style.',
        h1: 'Newspaper template: front page, school paper, vintage',
        tagline: 'Three newspaper layouts, each in three styles, with a masthead, columns and empty picture frames.',
        intro: 'A newspaper template is the page layout for a printed paper. These nine show a front page with a masthead and columns; a school newspaper with a bright masthead band; and a vintage paper with a blackletter masthead and tight columns. Only the HEADLINE and Weather labels are lettered. Type a twist, such as four columns, and it is a request.',
        useCases: [
            'a class newspaper for students',
            'a school notice paper',
            'a wall paper for a classroom',
            'a vintage-style page for a history project',
        ],
        faq: [
            {q: 'Does the masthead carry a real paper name?', a: 'No. The masthead is a sample. The name of your paper is yours to set.'},
            {q: 'Are the articles written?', a: 'No. The columns are grey placeholder lines for your own stories.'},
            {q: 'What makes the vintage style look old?', a: 'A blackletter masthead, tight columns and double rules on yellowed paper.'},
            {q: 'Where are the pictures?', a: 'The modern and classroom styles show framed photo boxes and empty picture frames, for your own images.'},
        ],
    },
}
